export default __webpack_public_path__ + "static/media/Sewa_Canada@2x.bd48c613.png";